<div class="container">
  <div class="container__files">
    <h5>Files</h5>
    <ng-container *ngIf="fileResources?.length; else empty">
      <table>
        <thead>
          <tr>
            <th class="file-name-th">File name</th>
            <th>Create date</th>
            <th>Owner</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fileResource of fileResources">
            <td>{{ fileResource.name }}</td>
            <td>{{ fileResource.created_at | date: 'MMM dd, y' }}</td>
            <td>{{ fileResource.user?.full_name }}</td>
            <td align="right">
              <button mat-icon-button (click)="downloadDocument(fileResource)" matTooltip="Download">
                <mat-icon>cloud_download</mat-icon>
              </button>
              <button mat-icon-button (click)="deleteFile(fileResource)" matTooltip="Delete">
                <mat-icon svgIcon="delete"></mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
    <ng-template #empty>
      <div class="empty">No files found</div>
    </ng-template>
    <button class="ml-2 xs:hidden add-task" color="primary" mat-flat-button (click)="fileInput.click()">
      <mat-icon class="icon-size-20 mr-1" [svgIcon]="'backup'"></mat-icon>
      <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput />
      Upload Attachment
    </button>
  </div>
  <div class="container__comments">
    <h5>Comments</h5>
    <comment-view [relatedToId]="relatedToId" [relatedToType]="relatedToType" [account]="account"></comment-view>
  </div>
</div>
